import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'

export default class extends Controller {
  static values = {
    reactionParams: Object,
    reactionType: String,
    toggleReactionUrl: String,
    unauthenticatedUserId: String,
  }

  connect(){
    this.resetOrStartAbortController()

    // Response
    document.addEventListener("turbo:before-fetch-response",
      (e) => {
        this.element.dataset.loading = false
      },
      {
        signal: this.abortController.signal,
      },
    )
  }

  disconnect(){
    if (this.abortController){
      this.abortController.abort('Disconnected')
    }
  }

  resetOrStartAbortController(){
    if(this.abortController){
      delete this.abortController;
    }

    this.abortController = new AbortController();
  }

  async toggleReaction(e){
    if (this.toggleReactionUrlValue){
      this.element.dataset.loading = true

      await post(this.toggleReactionUrlValue, {
        contentType: 'application/json',
        body: JSON.stringify({
          reaction: {
            ...this.reactionParamsValue,
            reaction_type: this.reactionTypeValue,
            unauthenticated_user_id: this.unauthenticatedUserIdValue,
          },
        }),
        responseKind: 'turbo-stream',
      })
    }
  }
}
